import { ca } from '@cian/analytics';

export function trackFormSending() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'cianDobro',
    action: 'click',
    label: 'send_form',
  });
}
